<template>
    <div>
        <div class="email-settings vx-card p-6">
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label required">{{ $t('settings.emailProtocol') }}</label>
                    <v-select class="w-full" v-model="dataEmailNew.emailProtocol" :clearable="false"
                              :options="protocolOptions"
                              :reduce="(options) => options.value" v-validate="'required'" name="emailProtocol">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('emailProtocol') }}</span>
                </div>
                <div class="vx-col w-1/2">
                    <label class="vs-input--label required">{{ $t('settings.sender') }}</label>
                    <vs-input v-model="dataEmailNew.emailSentFromName" name="sender" class="w-full"
                              v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('sender') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.smtpHost') }}</label>
                    <vs-input v-model="dataEmailNew.emailSmtpHost" name="smtpHost" class="w-full"
                              v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('smtpHost') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.smtpUser') }}</label>
                    <vs-input v-model="dataEmailNew.emailSmtpUser" name="smtpUser" class="w-full"
                              v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('smtpUser') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.smtpPassword') }}</label>
                    <vs-input v-model="dataEmailNew.emailSmtpPass" name="smtpPassword"
                              class="w-full" v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.smtpPort') }}</label>
                    <vs-input v-model="dataEmailNew.emailSmtpPort" name="smtpPort" class="w-full"
                              v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('smtpPort') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.securityType') }}</label>
                    <v-select class="w-full" v-model="dataEmailNew.emailSmtpSecurityType" :clearable="false"
                              :options="smtpSecurityOptions" v-validate="'required'"
                              :reduce="(options) => options.value" name="securityType">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('securityType') }}</span>
                </div>
                <div class="vx-col w-1/2 mt-4">
                    <label class="vs-input--label required">{{ $t('settings.receiver') }}</label>
                    <vs-input v-model="dataEmailNew.sentATestMailTo" name="receiver" class="w-full"
                              v-validate="'required'"/>
                    <span class="text-danger text-sm">{{ errors.first('receiver') }}</span>
                </div>
            </div>
        </div>
        <div class="mt-4 flex justify-end">
            <vs-button color="primary" icon-pack="feather" icon="icon-check" @click="saveEmail">{{ $t('button.save') }}
            </vs-button>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    data() {
        return {
            dataEmailNew: {},
            passwordFieldType: 'password',
            protocolOptions: [
                {value: "smtp", label: "SMTP"},
                {value: "imap", label: "IMAP"}
            ],
            smtpSecurityOptions: [
                {value: "", label: "Không xác định"},
                {value: "ssl", label: "SSL"},
                {value: "tls", label: "TLS"},
            ]
        }
    },
    created() {
        this.getEmail();
    },
    methods: {
        checkPass() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        saveEmail() {
            let form = {
                emailProtocol: this.dataEmailNew.emailProtocol,
                emailSentFromName: this.dataEmailNew.emailSentFromName,
                emailSmtpHost: this.dataEmailNew.emailSmtpHost,
                emailSmtpUser: this.dataEmailNew.emailSmtpUser,
                emailSmtpPass: this.dataEmailNew.emailSmtpPass,
                emailSmtpPort: this.dataEmailNew.emailSmtpPort,
                emailSmtpSecurityType: this.dataEmailNew.emailSmtpSecurityType,
                sentATestMailTo: this.dataEmailNew.sentATestMailTo,
            }
            this.$vs.loading()
            this.$crm.post(`/setting/organization-email-setting/save`, form).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật cấu hình thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        getEmail() {
            this.$vs.loading()
            this.$crm.get(`/setting/organization-email-setting/find-by-organization-id`).then((response) => {
                this.$vs.loading.close()
                this.dataEmailNew = response.data
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        }
    }
}
</script>

<style scoped>
.required::after {
    content: '*';
    color: red;
}
</style>
